export const TIPOS_IMPEDIMENTO: { id: number; descricao: string }[] = [
  { id: 1, descricao: 'Licença' },
  { id: 2, descricao: 'Férias' },
  { id: 3, descricao: 'Redução de jornada' },
]

export const TIPO_IMPEDIMENTO_REDUCAO_JORNADA = 3

export class MotoristaImpedimentoVm {
  public id = 0
  public motoristaId = 0
  public motoristaNome = ''
  public tipoImpedimentoId = 0
  public tipo = ''
  public dataInicio = ''
  public dataFim = ''
  public horaInicio: string | null = null
  public horaFim: string | null = null
  public resumo = ''
  public observacao: string | null = null
}

export class CreateMotoristaImpedimentoModel {
  public motoristaId = 0
  public tipoImpedimentoId = 0
  public dataInicio = ''
  public dataFim = ''
  public horaInicio: string | null = null
  public horaFim: string | null = null
  public observacao = ''
}

// POST MotoristaImpedimento/search — datas vazias: início = hoje, fim = 30 dias à frente.
// A mensagem da resposta diz o período que foi aplicado.
export class SearchMotoristaImpedimentoModel {
  public dataInicio?: string
  public dataFim?: string
  public tipoImpedimentoId?: number | null
  public motoristaId?: number | null
}
